import getScrollbarWidth from '../functions/getScrollbarWidth';
import scrollTo from '../functions/scrollTo';

const DISABLE_MOVE_CLASS = 'disable-move';
const POSITION_ATTR = 'data-pos';

let disable = function() {
  let position = window.scrollY;
  let body = document.body;

  body.setAttribute(POSITION_ATTR, position);
  body.classList.add(DISABLE_MOVE_CLASS);
  scrollTo(0, position);
  body.style.marginRight = `${getScrollbarWidth()}px`;
};

let enable = function() {
  let body = document.body;

  body.classList.remove(DISABLE_MOVE_CLASS);
  body.style.removeProperty('margin-right');
};

export default {
  disable: disable,
  enable: enable
};
